import { GetBondsPromotionsResponse } from '@goldwasserexchange/actor/rest-services';
import { BondList } from '../../../bonds';
import { BondSameIssuerResponse } from '../../../bonds/sameIssuer/type';

const sAccIdMappingFn = (bondList: BondList | BondSameIssuerResponse) => `${bondList['S_ACC.ID']}`;

export const mapSAccId = (bondsList?: BondList[] | BondSameIssuerResponse[] | GetBondsPromotionsResponse[]) => (bondsList ?? []).map((bondList) => sAccIdMappingFn(bondList));
